export const lessData = `
@link: url('{{Offers[0].ImageUrl or ""}}');

body{
height: 100%;
width: 100%;
    background-image: @link;
}
`;

export const sassData = `
@import "one";
$link: url('{{Offers[0].ImageUrl or ""}}');

body{
    height: 100%;
    width: 100%;
    background-image: $link;
    background-size: cover;
    background-repeat: no-repeat;
} 
`;

let tmp = `
#lib() {
  .colors() {
    @primary: blue;
    @secondary: green;
  }
  .rules(@size) {
    border: @size solid white;
  }
}

.box when (#lib.colors[@primary] = blue) {
  width: 100px;
  height: ($width / 2);
}

.bar:extend(.box) {
  @media (min-width: 600px) {
    width: 200px;
    #lib.rules(1px);
  }
}`
